module.exports = __webpack_public_path__ + "static/media/oculus.f5bcd699.png";